<template>
  <v-container class="cmp-settings-label-settings dt-sidewindow submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout :tabs="labelSettingsTabs" tabPanelColor="secondary">


    
   

        <gtab
          v-for="tab in taskTable"
          :id="getTabID(tab)"
          :key="tab"
        >
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    taskSettingsData &&
                      taskSettingsData[`${tab}_task_templates`] &&
                      taskSettingsData[`${tab}_task_templates`].length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('tab_title_tasks')"
              >
                <SettingsTaskTemplates
                  v-if="taskSettingsData"
                  :settingsData="taskSettingsData"
                  :externalTable="tab"
                />
                <!-- @add_click="onTaskTemplateAddClick"
                  @delete="onTaskTemplateDeleted" -->
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    taskSettingsData &&
                      taskSettingsData[`${tab}_task_template_groups`] &&
                      taskSettingsData[`${tab}_task_template_groups`].length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('task_template_group')"
              >
                <SettingsTaskTemplateGroups
                  v-if="taskSettingsData"
                  :settingsData="taskSettingsData"
                  :externalTable="tab"
                 
                />
                <!-- @selected="onTaskTemplateGroupSelected"
                  @delete="onTaskTemplateGroupDeleted"
                  @updated="onTaskTemplateGroupUpdated"
                  @add_click="onTemplateTaskGroupAddClick" -->
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('task_template_group_items')">
                <SettingsTaskGroupItem
                  :externalTable="tab"
                  :settingsData="taskSettingsData"
                  v-if="taskSettingsData"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";


import {
  createTextFieldConfig,
  EventHooks,
} from "../../../../plugins/text-field";


import { taskSettingsActions } from "../../store/task/actions";

import { clientName } from "../../../../services/http/http-client";


import SettingsTaskTemplateGroups from "../settings-plugins/settings-task-template-groups.vue";
import SettingsTaskTemplates from "../settings-plugins/settings-task-templates.vue";
import SettingsTaskGroupItem from "../settings-plugins/settings-task-group-item.vue";
export default {
  components: {
    SettingsTaskTemplateGroups,
    SettingsTaskTemplates,
    SettingsTaskGroupItem,
    
  },
  mounted: function () {
    this.fetchData();
  },
  data: function () {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur,
      }),

      selectedTaxGroup: null,
      clientName: clientName,

      taskTable: ["general","booking","licence", "release", "product","contract_reminder"],
      //"contract"

      //API Config Data
      formData: null,
      minimizedFormItems: [],
    };
    //MARK: Data Function
  },
  watch: {
    taskSettingsData: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.formData = newValue;
      },
    },
  },
  mixins: [
    createDTGridHost(),
  ],
  computed: {
    ...mapGetters(storeNS, {
      taskSettingsData: "taskSettingsData",
    }),
    labelSettingsTabs: function () {
      return [
        {
          route: "tasks_general",
          value: this.$t("tasks_general"),
        },
        {
          route: "tasks_booking",
          value: this.$t("tasks_booking"),
        },
        {
          route: "tasks_licences",
          value: this.$t("tasks_licences"),
        },
        {
          route: "tasks_releases",
          value: this.$t("tasks_releases"),
        },
        {
          route: "tasks_products",
          value: this.$t("tasks_products"),
        },
        {
          route: "tasks_contract",
          value: this.$t("tasks_contract"),
        },
      ];
    },

  },
  methods: {
    
    ...mapActionObject(storeNS, taskSettingsActions),
    getTabID:function(tab){
    
      //:id="tab == 'general'||tab == 'booking'||tab == 'contract' ? `tasks_${tab}` : `tasks_${tab}s`"
      if(tab == 'general'||tab == 'booking'){
        return `tasks_${tab}`
      }
      if(tab == 'contract_reminder'){
        return `tasks_contract`
      }

      return `tasks_${tab}s`
    },

    fetchData: function () {
      this[ActionTypes.TaskSettingsData.FETCH.ALL]();
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-label-settings {
  background: white;
  padding: 8px;

  .dt-grid-layout {
    height: calc(100vh - 108px);
  }
  // .grids-page {
  //   height: calc(100vh - 112px) !important;
  // }

  .invoice-notifications {
    .dt-checkbox-control {
      padding-top: 10px;
      padding-left: 3px;
      .dt-checkbox {
        max-width: 40px;
        margin-right: 10px;
        margin-top: 5px;
      }
      .dt-checkbox-label {
        flex: 1;
      }
    }
  }

  .api-item {
    &:not(:first-child) {
      border-top: 1px solid var(--sprt-75);
    }
    &:not(:last-child) {
      /* background: gainsboro; */
      & > .api-item-form {
        /* background: forestgreen; */
        /* padding-bottom: 32px; */
      }
    }
    &.minimized:not(:last-child) {
      .api-item-title-bar {
        border-bottom: none;
      }
    }
    .api-item-title-bar {
      border-bottom: 1px solid var(--sprt-85);

      .api-options {
        .dt-icon-container:first-child {
          border-left: 1px solid var(--sprt-85);
        }
        .dt-icon-container:not(:last-child) {
          border-right: 1px solid var(--sprt-85);
        }
      }
    }
  }
  .api-item-form {
  }
}
</style>
